<ion-content>
  <ion-split-pane when="(min-width: 1280px)" contentId="main">
    <ion-menu contentId="main" style="--side-max-width: 330px" swipeGesture="false">
      <ion-menu-toggle auto-hide="false">
        <div class="flex flex-col pt-safe-t">
          <div class="!mx-2 flex items-center rounded-md px-3 py-1">
            <img src="https://nbg1.your-objectstorage.com/mtjr/logo.svg" height="40" alt="" />
            <ion-text class="mx-4 my-3">
              <p class="text-primary text-2xl font-bold">متجر</p>
              <p class="text-surface/20 text-md mt-0.5">{{ "COMMON.ONLINE_SHOPPING_PLATFORM" | translate }}</p>
            </ion-text>
          </div>
          <!-- todo: fixme: wallet -->
          <!-- <div class="bg-medium/10 h-[2px]"></div>
              <ion-item lines="none ms-2 " routerLink="wallet" routerLinkActive="text-primary">
                <ion-icon slot="start" name="wallet" />
                <ion-label>
                  <span>{{ 'WALLET.BALANCE' | translate }}</span>
                </ion-label>
                <ion-text class="text-success ms-au">
                  {{ walletStore.walletBalance() | quarterFloor | vxCurrency }}
                </ion-text>
              </ion-item> -->
          <div class="bg-medium/10 h-[2px]"></div>
          <ion-list class="bg-transparent *:ms-2">
            <ion-item
              lines="none"
              class="cursor-pointer hover:bg-medium/10"
              routerLink="vendors"
              routerLinkActive="text-primary"
            >
              <ion-label>{{ "COMMON.HOME" | translate }}</ion-label>
              <ion-icon slot="start" name="home"></ion-icon>
            </ion-item>

            <ion-item
              routerLink="orders"
              class="cursor-pointer hover:bg-medium/10"
              lines="none"
              routerLinkActive="text-primary"
            >
              <ion-label>{{ "USER.MY_ORDERS" | translate }}</ion-label>
              <ion-icon slot="start" name="orders"></ion-icon>
            </ion-item>

            <ion-item
              [routerLink]="['create-order']"
              class="cursor-pointer hover:bg-medium/10"
              lines="none"
              routerLinkActive="text-primary"
            >
              <ion-label>{{ "ORDERS.EXTERNAL_ORDER" | translate }}</ion-label>
              <ion-icon slot="start" name="pencil-outline"></ion-icon>
            </ion-item>
            <ion-item routerLink="account/addresses" lines="none" routerLinkActive="text-primary">
              <ion-label>{{ "USER.MY_ADDRESSES" | translate }}</ion-label>
              <ion-icon slot="start" name="location"></ion-icon>
            </ion-item>
            <!-- <div class="mb-3 mt-3">
                  <ion-item>
                    <div slot="start"></div>
                    <ion-label class="!text-medium">{{ 'USER.UI_SETTINGS' | translate }}</ion-label>
                  </ion-item>
                </div> -->
            @if (authStore.isAuthenticated()) {
              <ion-item lines="none" routerLink="settings" routerLinkActive="text-primary">
                <ion-label>{{ "SETTINGS.TITLE" | translate }}</ion-label>
                <ion-icon slot="start" name="settings" />
              </ion-item>
            }
            <ion-item
              lines="none"
              (click)="themeSwitch.toggleTheme(); $event.stopPropagation()"
              class="cursor-pointer hover:bg-medium/10"
            >
              <ion-label>
                {{ "COMMON.APPEARANCE" | translate }}
              </ion-label>
              <ion-icon slot="start" name="theme" />
              <mtjr-theme-toggle slot="end" #themeSwitch [disabled]="true" />
            </ion-item>
          </ion-list>
        </div>
      </ion-menu-toggle>

      <ion-footer class="bg-light shadow-sm">
        <ion-item>
          <ion-text>
            {{ "COMMON.LANGUAGE" | translate }}
          </ion-text>
          <mtjr-language-switcher slot="end" />
        </ion-item>
        <ion-item class="ios-pb my-2 !ms-0" lines="none">
          <ion-avatar slot="start">
            <img [src]="userStore.profileImage()" referrerPolicy="no-referrer" />
          </ion-avatar>

          <ion-label class="flex flex-col">
            @if (userStore.name(); as name) {
              <p class="!text-dark !m-0">{{ userStore.name() }}</p>
            } @else {
              <ion-skeleton-text animated="true" class="mt-2 rounded-md" style="width: 30%" />
            }
            @if (userStore.userName(); as email) {
              <p class="text-light !m-0 truncate">{{ email }}</p>
            } @else {
              <ion-skeleton-text animated="true" class="my-1 rounded-md" style="width: 50%" />
            }
          </ion-label>
          <ion-button fill="clear" slot="end" size="large" mode="md" (click)="signOut()">
            <ion-icon slot="icon-only" name="logout" />
          </ion-button>
        </ion-item>
      </ion-footer>
    </ion-menu>
    <ion-tabs class="ion-page" id="main">
      <ion-tab-bar slot="bottom" class="xl:hidden">
        <ion-tab-button tab="vendors">
          <ion-icon name="home"></ion-icon>
          <ion-label>{{ "COMMON.HOME" | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="orders">
          <ion-icon name="orders"></ion-icon>
          <ion-label>{{ "ORDERS.ORDERS" | translate }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-split-pane>
</ion-content>
